Shopify.updateCartOnAdd = function() {
  $.get('/cart', function(data) {
    $('.top-cart').html($(data).find('.top-cart').html());
    $('.mobile-cart-count').html($(data).find('.mobile-cart-count').html());
  });
  $.magnificPopup.close();
};

Shopify.getCart = function(callback) {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      if (callback && typeof callback === 'function') {
        callback(cart);
      }
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
      if (callback && typeof callback === 'function') {
        callback(null);
      }
    });
};

Shopify.updateCartNote = function(note, callback) {
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ note: note })
  })
    .then(response => response.json())
    .then(updatedCart => {
      if (callback && typeof callback === 'function') {
        callback(updatedCart);
      }
    })
    .catch(error => {
      console.error('Error updating cart note:', error);
      if (callback && typeof callback === 'function') {
        callback(null);
      }
    });
};

let cartUpdateType = 'none';

function enableLoading() {
  const preloader = document.querySelector('cart-drawer .cart-preloader');
  if (preloader) {
    preloader.classList.remove('hidden-el');
  }
}

function disableLoading() {
  const preloader = document.querySelector('cart-drawer .cart-preloader');
  if (preloader) {
    preloader.classList.add('hidden-el');
  }
}

function updatePromoThreshold() {
  const promoSection = document.querySelector('promo-section');
  const promoEnabledInput = document.getElementById('promo-enabled');
  if (!promoSection || !promoEnabledInput || promoEnabledInput.value !== 'true') {
    return;
  }

  const cartDataElement = document.getElementById('cart-total-data');
  const currency = cartDataElement.getAttribute('data-currency');
  const cartTotal = parseFloat(cartDataElement.getAttribute('data-cart'));

  const promoThresholdElement = document.getElementById('promo-threshold');
  const promoThresholdConvertedElement = document.getElementById('promo-threshold-converted');
  const promoThresholdValue = parseFloat(promoThresholdElement.value);

  const secondPromoThresholdElement = document.getElementById('second-promo-threshold');
  const secondPromoThresholdConvertedElement = document.getElementById('second-promo-threshold-converted');
  const secondPromoThresholdValue = parseFloat(secondPromoThresholdElement.value);

  if (Shopify.currency.active !== 'USD') {

    const convertedPromoThreshold = Currency.convert(promoThresholdValue, "USD", Shopify.currency.active);
    promoThresholdConvertedElement.value = convertedPromoThreshold;

    const convertedSecondPromoThreshold = Currency.convert(secondPromoThresholdValue, "USD", Shopify.currency.active);
    secondPromoThresholdConvertedElement.value = convertedSecondPromoThreshold;

    const checkoutButton = document.querySelector('.cart-checkout-button');
    const tooltipSpan = document.querySelector('.tooltip-message');

    fetch('/cart.js')
      .then(response => response.json())
      .then(cartData => {
        const promoItemInputs = document.querySelectorAll('.promo-item input');
        const promoItemIds = Array.from(promoItemInputs).map(input => parseInt(input.value, 10));
        const promoItemInCart = cartData.items.some(item => promoItemIds.includes(item.variant_id));

        if (cartTotal < convertedPromoThreshold) {
          promoSection.classList.add('visually-hidden');
          if (checkoutButton) {
            checkoutButton.removeAttribute('disabled');
            checkoutButton.setAttribute('href', '/checkout');
          }
          if (tooltipSpan) {
            tooltipSpan.classList.add('visually-hidden');
          }
        } else if (cartTotal >= convertedPromoThreshold && promoItemInCart) {
          promoSection.classList.remove('visually-hidden');
          if (checkoutButton) {
            checkoutButton.removeAttribute('disabled');
            checkoutButton.setAttribute('href', '/checkout');
          }
          if (tooltipSpan) {
            tooltipSpan.classList.add('visually-hidden');
          }
        } else if (cartTotal >= convertedPromoThreshold && !promoItemInCart) {
          promoSection.classList.remove('visually-hidden');
          if (checkoutButton) {
            checkoutButton.setAttribute('disabled', 'disabled');
            checkoutButton.setAttribute('href', '#');
          }
          if (tooltipSpan) {
            tooltipSpan.classList.remove('visually-hidden');
          }
        }
      })
      .catch(error => {
        console.error('Error fetching cart data:', error);
      });
  }
}

function cartItemTooltip() {
  const tooltip = document.querySelector('.cart-item-tooltip');
  if (!tooltip) return;

  const icon = tooltip.querySelector('.cart-item-tooltip-icon');
  const message = tooltip.querySelector('.cart-item-tooltip-msg');

  if (!icon || !message) return;

  function showTooltip() {
    icon.style.display = 'none';
    message.style.display = 'inline-block';
    document.addEventListener('click', onDocumentClick);
  }

  function hideTooltip() {
    message.style.display = 'none';
    icon.style.display = 'inline-block';
    document.removeEventListener('click', onDocumentClick);
  }

  function onDocumentClick(event) {
    if (!tooltip.contains(event.target) || event.target === message) {
      hideTooltip();
    }
  }

  icon.addEventListener('click', function () {
    showTooltip();
  });

  message.addEventListener('click', function () {
    hideTooltip();
  });

  hideTooltip();
}

class PairWithItem extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
  }

  connectedCallback() {
    if (!this.initialized) {
      this.initialized = true;
      this.initializeAddButton();
    }
  }

  initializeAddButton() {
    const addButton = this.querySelector(".pair-with-add");
    if (addButton && !addButton.dataset.initialized) {
      addButton.addEventListener("click", this.handleAddClick.bind(this));
      addButton.dataset.initialized = true;
    }
  }

  handleAddClick(event) {
    const button = event.target;
    const productId = button.dataset.productId;
    this.addPairWithProduct(productId);
  }

  addPairWithProduct(id) {
    const body = JSON.stringify({
      items: [{
        id: id,
        quantity: 1
      }],
    });

    enableLoading();
    cartUpdateType = 'add';

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: body
    })
    .then((response) => response.json())
    .then((state) => {
      document.querySelector('cart-drawer').render(state).then(() => {
      });
    })
    .catch((error) => {
      console.error('Error adding pair-with product:', error);
    });
  }
}

customElements.define('pair-with-item', PairWithItem);

document.addEventListener("DOMContentLoaded", function() {
  const pairWithElements = document.querySelectorAll('pair-with-item');
  pairWithElements.forEach(pairWithElement => {
    if (pairWithElement) {
      pairWithElement.initializeAddButton();
    }
  });
});

class PromoProdSection extends HTMLElement {
  constructor() {
    super();
    console.log('[PromoProd] constructor');
    this.scrollPosition = 0;
    this.debounceTimeout = null;
    this.initializePromoRadios();
  }

  connectedCallback() {
    console.log('[PromoProd] connectedCallback, initialized:', !!this.initialized);
    if (!this.initialized) {
      this.initialized = true;
      this.initializePromoRadios();
    }
  }

  initializePromoRadios() {
    this.radioButtons = this.querySelectorAll('.promo-radio');
    console.log('[PromoProd] initializePromoRadios count:', this.radioButtons.length);
    const ids = Array.from(this.radioButtons).map(r => r.value);
    console.log('[PromoProd] promo variant ids:', ids);
    this.radioButtons.forEach(radio => {
      if (!radio.dataset.promoBound) {
        radio.addEventListener('change', this.handleRadioChange.bind(this));
        radio.dataset.promoBound = 'true';
      }
    });
  }

  handleRadioChange(event) {
    const target = event && event.target ? event.target : null;
    console.log('[PromoProd] handleRadioChange fired for', target ? { id: target.value, handle: target.id } : null);
    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = setTimeout(() => {
      this.processRadioChange(event);
    }, 300);
  }

  processRadioChange(event) {
    const selectedProductId = event && event.target ? event.target.value : null;
    console.log('[PromoProd] processRadioChange start, selectedProductId:', selectedProductId);
    this.saveScrollPosition();

    const cartDrawer = document.querySelector('cart-drawer');
    console.log('[PromoProd] cartDrawer found:', !!cartDrawer);
    enableLoading();
    console.log('[PromoProd] loading enabled');

    this.removeExistingPromoProducts(cartDrawer, selectedProductId)
      .then((res) => {
        console.log('[PromoProd] removeExistingPromoProducts done', res);
        return this.addPromoProduct(selectedProductId);
      })
      .then((addRes) => {
        console.log('[PromoProd] addPromoProduct done', addRes);
        return cartDrawer ? cartDrawer.render() : Promise.resolve();
      })
      .then(() => {
        console.log('[PromoProd] cart render done');
        this.restoreScrollPosition();
        disableLoading();
        console.log('[PromoProd] loading disabled');
      })
      .catch((err) => {
        console.error('[PromoProd] error in processRadioChange', err);
        disableLoading();
      });
  }

  removeExistingPromoProducts(cartDrawer, excludeProductId) {
    console.log('[PromoProd] removeExistingPromoProducts start, excludeProductId:', String(excludeProductId));
    return (cartDrawer ? cartDrawer.fetchCart() : Promise.resolve({ items: [] })).then(cartData => {
      console.log('[PromoProd] fetched cart items:', cartData && cartData.items ? cartData.items.length : 0);
      const promoProductInputs = this.querySelectorAll('.promo-radio');
      const promoProductIds = Array.from(promoProductInputs).map(radio => String(radio.value));
      console.log('[PromoProd] promo candidate ids:', promoProductIds);

      const promoItemInCart = (cartData.items || []).find(item =>
        promoProductIds.includes(String(item.id)) && String(item.id) !== String(excludeProductId)
      );
      console.log('[PromoProd] promoItemInCart:', promoItemInCart ? { id: promoItemInCart.id, key: promoItemInCart.key } : null);

      if (promoItemInCart) {
        const body = JSON.stringify({ id: promoItemInCart.key, quantity: 0 });
        console.log('[PromoProd] removing existing promo item with body:', body);
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: body
        }).then(response => response.json()).then(json => {
          console.log('[PromoProd] remove existing promo response:', json);
          return json;
        });
      } else {
        console.log('[PromoProd] no existing promo item to remove');
        return Promise.resolve('no-op');
      }
    });
  }

  addPromoProduct(productId) {
    const body = JSON.stringify({ items: [{ id: productId, quantity: 1 }] });
    console.log('[PromoProd] addPromoProduct body:', body);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: body
    }).then(response => response.json()).then(json => {
      console.log('[PromoProd] addPromoProduct response:', json);
      return json;
    });
  }

  saveScrollPosition() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      const container = cartDrawer.querySelector('.cart-scroll');
      this.scrollPosition = container ? container.scrollTop : 0;
      console.log('[PromoProd] saveScrollPosition:', this.scrollPosition);
    }
  }

  restoreScrollPosition() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      const container = cartDrawer.querySelector('.cart-scroll');
      if (container) {
        container.scrollTop = this.scrollPosition;
        console.log('[PromoProd] restoreScrollPosition:', this.scrollPosition);
      }
    }
  }
}

customElements.define('promo-prod-section', PromoProdSection);


document.addEventListener('DOMContentLoaded', function() {
  const promoProdEl = document.querySelector('promo-prod-section');
  console.log('[PromoProd] DOMContentLoaded, element present:', !!promoProdEl);
  if (promoProdEl) {
    promoProdEl.initializePromoRadios();
  }
});

class PromoSection extends HTMLElement {
  constructor() {
    super();
    this.scrollPosition = 0;
    this.debounceTimeout = null;
    this.initializePromoRadios();
  }

  connectedCallback() {
    if (!this.initialized) {
      this.initialized = true;
      this.initializePromoRadios();
    }
  }

  initializePromoRadios() {
    this.radioButtons = this.querySelectorAll('.promo-radio');

    this.radioButtons.forEach(radio => {
      radio.addEventListener('change', this.handleRadioChange.bind(this));
    });
  }

  handleRadioChange(event) {
    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = setTimeout(() => {
      this.processRadioChange(event);
    }, 300);
  }

  processRadioChange(event) {
    const selectedProductId = event.target.value;
    const selectedTier = event.target.getAttribute('data-tier');
    this.saveScrollPosition();

    const cartDrawer = document.querySelector('cart-drawer');
    enableLoading();

    this.removePromoProduct(cartDrawer, selectedProductId, selectedTier)
      .then(() => {
        this.addPromoProduct(selectedProductId);
      })
      .catch(error => {
        disableLoading();
      });
  }

  removePromoProduct(cartDrawer, excludeProductId, tier) {
    return cartDrawer.fetchCart().then(cartData => {
      const promoProductInputs = this.querySelectorAll(`.promo-radio[data-tier="${tier}"]`);
      const promoProductIds = Array.from(promoProductInputs).map(radio => radio.value);
      const promoProductInCart = cartData.items.find(item =>
        promoProductIds.includes(String(item.id)) && String(item.id) !== excludeProductId
      );

      if (promoProductInCart) {
        const body = JSON.stringify({ id: promoProductInCart.key, quantity: 0 });

        return fetch("/cart/change.js", {
          method: "POST",
          headers: { 'Content-Type': 'application/json' },
          body: body
        }).then(response => response.json());
      } else {
        return Promise.resolve();
      }
    });
  }

  addPromoProduct(productId) {
    const body = JSON.stringify({
      items: [{ id: productId, quantity: 1 }],
    });

    fetch("/cart/add.js", {
      method: "POST",
      headers: { 'Content-Type': 'application/json' },
      body: body
    })
    .then(response => response.json())
    .then(state => {
      return document.querySelector('cart-drawer').render(state);
    })
    .then(() => {
      this.restoreScrollPosition();
      disableLoading();
    })
    .catch(error => {
      disableLoading();
    });
  }

  saveScrollPosition() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      this.scrollPosition = cartDrawer.querySelector('.cart-scroll').scrollTop;
    }
  }

  restoreScrollPosition() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawer.querySelector('.cart-scroll').scrollTop = this.scrollPosition;
    }
  }
}

customElements.define('promo-section', PromoSection);

document.addEventListener("DOMContentLoaded", function() {
  const promoElement = document.querySelector('promo-section');
  if (promoElement) {
    promoElement.initializePromoRadios();
  }
});

class CartSamples extends HTMLElement {
  constructor() {
    super();

    this.checkboxes = this.querySelectorAll(".cart-minis input");
    this.cartDrawer = this.closest('cart-drawer');
    this.debounceTimeout = null;

    this.checkboxes.forEach(checkbox => {
      checkbox.addEventListener('click', this.onChange.bind(this));
    });

    this.max = 2;
    this.checkboxAbilities();
  }

  connectedCallback() {
    if (!this.initialized) {
      this.initialized = true;
      this.checkboxes = this.querySelectorAll(".cart-minis input");
      this.cartDrawer = this.closest('cart-drawer');

      this.checkboxes.forEach(checkbox => {
        checkbox.addEventListener('click', this.onChange.bind(this));
      });

      this.max = 2;
      this.checkboxAbilities();
    }
  }

  disconnectedCallback() {
    this.initialized = false;
  }

  onChange(event) {
    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = setTimeout(() => {
      this.processChange(event);
    }, 300);
  }

  processChange(event) {
    const checkbox = event.target;
    const productId = checkbox.value;


    if (checkbox.checked) {
      this.addSample(productId);
    } else {
      this.removeSample(productId);
    }
    this.checkboxAbilities();
  }

  checkboxAbilities() {
    const checkboxes = Array.from(this.querySelectorAll("input[type=checkbox]"));
    const totalCheckedValue = this.checkedValue();

    checkboxes.forEach(checkbox => {
      if (checkbox.checked) {
        return;
      }

      const value = Number(checkbox.dataset.checkedValue);

      if ((totalCheckedValue + value) > this.max) {
        checkbox.disabled = true;
      } else {
        checkbox.disabled = false;
      }
    });
  }

  addSample(id) {

    const body = JSON.stringify({
      items: [{
        id: id,
        quantity: 1
      }],
    });

    this.saveScrollPosition();
    enableLoading();

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: body
    })
    .then((response) => response.json())
    .then((state) => {
      document.querySelector('cart-drawer').render(state).then(() => {
        disableLoading();
        this.restoreScrollPosition();
      });
    })
    .catch((error) => {
      console.error('Error adding sample:', error);
    });
  }

  removeSample(id) {
    enableLoading();

    const body = JSON.stringify({
      id: id,
      quantity: 0,
    });

    this.saveScrollPosition();

    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: body
    }).then((response) => {
      return response.json();
    }).then((state) => {
      this.cartDrawer.render(state).then(() => {
        this.restoreScrollPosition();
      });
    }).catch((error) => {
      console.error('Error removing sample:', error);
      disableLoading();
    });
  }

  saveScrollPosition() {
    this.scrollPosition = this.cartDrawer.querySelector('.cart-scroll').scrollTop;
  }

  restoreScrollPosition() {
    this.cartDrawer.querySelector('.cart-scroll').scrollTop = this.scrollPosition;
  }

  checkedValue() {
    var checkedInputs = this.querySelectorAll(".cart-minis input:checked");
    var checkedValue = Array.from(checkedInputs)
      .map(element => Number(element.dataset.checkedValue))
      .reduce((a, b) => a + b, 0);

    return checkedValue;
  }
}

customElements.define('cart-samples', CartSamples);

document.addEventListener("DOMContentLoaded", () => {
  const cartSamplesElement = document.querySelector('cart-samples');
if (cartSamplesElement) {
  cartSamplesElement.checkboxes = cartSamplesElement.querySelectorAll(".cart-minis input");
  cartSamplesElement.cartDrawer = cartSamplesElement.closest('cart-drawer');

  cartSamplesElement.checkboxes.forEach(checkbox => {
    checkbox.addEventListener('click', cartSamplesElement.onChange.bind(cartSamplesElement));
  });

  cartSamplesElement.max = 2;
  cartSamplesElement.checkboxAbilities();
}
});

class GiftBox extends HTMLElement {
  constructor() {
    super();
    // Gift wrap variant ID
    this.giftBoxingProductId = 812526797;
    // Product IDs that cannot be gifted alone
    this.restrictedProductIds = [1687467163737, 1687442587737, 6056491450555, 2016087801945];
    // Debounce timeout for note saves
    this.saveNoteTimeout = null;
    // Flag to prevent duplicate saves
    this.isSaving = false;
    // Last saved note to track state
    this.lastSavedNote = '';
    // Bind handlers
    this.debouncedSave = this.createDebouncedSave();
  }

  connectedCallback() {
    if (!this.initialized) {
      this.initialized = true;
      this.cartDrawer = this.closest('cart-drawer');
      this.checkbox = this.querySelector("#cart-gift-boxing");
      this.noteFields = {
        to: this.querySelector("#gift-to"),
        from: this.querySelector("#gift-from"),
        message: this.querySelector("#gift-message")
      };
      
      this.initializeEventListeners();
      this.syncWithCartState();
    }
  }

  disconnectedCallback() {
    this.initialized = false;
    // Clean up timeout
    if (this.saveNoteTimeout) {
      clearTimeout(this.saveNoteTimeout);
    }
  }

  // Initialize all event listeners
  initializeEventListeners() {
    if (this.checkbox) {
      this.checkbox.addEventListener("change", this.handleCheckboxChange.bind(this));
    }
    
    // Attach handlers to all note fields
    if (this.noteFields.to && this.noteFields.from && this.noteFields.message) {
      // Start/reset timer on input
      this.noteFields.to.addEventListener("input", this.debouncedSave);
      this.noteFields.from.addEventListener("input", this.debouncedSave);
      this.noteFields.message.addEventListener("input", this.debouncedSave);
      
    }
  }

  // Create debounced save handler using closure
  createDebouncedSave() {
    return () => {
      if (this.saveNoteTimeout) {
        clearTimeout(this.saveNoteTimeout);
      }
      
      this.saveNoteTimeout = setTimeout(async () => {
        this.saveNoteTimeout = null;
        await this.performSaveWithVerification();
      }, 100);
    };
  }

  // Get current note string from form fields
  getCurrentNoteString() {
    const to = this.noteFields.to?.value || "";
    const from = this.noteFields.from?.value || "";
    const message = this.noteFields.message?.value || "";
    return `To: ${to}, From: ${from}, Message: ${message}`;
  }

  // Perform save with verification and retry if needed
  async performSaveWithVerification() {
    if (this.isSaving) {
      // If already saving, schedule another check
      this.debouncedSave();
      return;
    }

    // Get current note before saving
    const noteToSave = this.getCurrentNoteString();
    
    // Skip if already saved
    if (noteToSave === this.lastSavedNote) {
      return;
    }

    this.isSaving = true;

    try {
      // Save the note
      await this.updateCartNote(noteToSave);
      
      // Mark as saved
      this.lastSavedNote = noteToSave;

      // Verify: check if form changed during save
      const currentNote = this.getCurrentNoteString();
      if (currentNote !== noteToSave) {
        // Form changed during save - trigger another save
        this.isSaving = false;
        this.debouncedSave();
      } else {
        this.isSaving = false;
      }
    } catch (error) {
      console.error('Error saving note:', error);
      this.isSaving = false;
      // Retry on error
      this.debouncedSave();
    }
  }

  // Sync UI with actual cart state
  async syncWithCartState() {
    if (!this.cartDrawer) return;
    
    try {
      const cartData = await this.cartDrawer.fetchCart();
      const hasGiftWrap = this.isGiftWrapInCart(cartData);
      
      // Initialize lastSavedNote from cart
      this.lastSavedNote = cartData.note || '';
      
      if (hasGiftWrap) {
        // Gift wrap is in cart - enable fields
        if (this.checkbox && this.checkbox.checked) {
          this.enableFields();
          this.hidePreloader();
        }
      } else {
        // No gift wrap in cart - clear everything
        if (this.checkbox && this.checkbox.checked) {
          this.checkbox.checked = false;
          this.collapseFields();
        }
        await this.clearNote();
      }
    } catch (error) {
      console.error('Error syncing gift wrap state:', error);
    }
  }

  // Handle checkbox state change
  handleCheckboxChange(event) {
    if (event.target.checked) {
      this.expandFields();
      this.showPreloader();
      this.disableFields();
      this.addGiftWrapToCart();
    } else {
      this.removeGiftWrapFromCart();
    }
  }

  // Add gift wrap product to cart
  async addGiftWrapToCart() {
    if (!this.cartDrawer) return;
    
    try {
      const cartData = await this.cartDrawer.fetchCart();
      
      // Check if cart only has restricted products (can't be gifted alone)
      if (this.hasOnlyRestrictedProducts(cartData)) {
        this.hidePreloader();
        this.enableFields();
        return;
      }

      // Check if gift wrap is already in cart
      if (this.isGiftWrapInCart(cartData)) {
        this.hidePreloader();
        this.enableFields();
        return;
      }

      // Add gift wrap product
      this.saveScrollPosition();
      
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: this.giftBoxingProductId, quantity: 1 }]
        })
      });
      
      const state = await response.json();
      
      await this.cartDrawer.render(state);
      this.restoreScrollPosition();
      
      // Verify gift wrap was added and enable fields
      const updatedCart = await this.cartDrawer.fetchCart();
      if (this.isGiftWrapInCart(updatedCart)) {
        this.hidePreloader();
        this.enableFields();
      }
    } catch (error) {
      console.error("Error adding gift wrap:", error);
      this.hidePreloader();
      if (this.checkbox) this.checkbox.checked = false;
    }
  }

  // Remove gift wrap product from cart
  async removeGiftWrapFromCart() {
    this.disableFields();
    
    if (!this.cartDrawer) return;
    
    try {
      // Clear note first
      await this.clearNote();
      
      const cartData = await this.cartDrawer.fetchCart();
      const giftBoxItem = cartData.items.find(item => item.id === this.giftBoxingProductId);

      // If gift wrap isn't in cart, just hide preloader and collapse
      if (!giftBoxItem) {
        this.hidePreloader();
        this.collapseFields();
        return;
      }

      // Remove gift wrap from cart
      this.saveScrollPosition();
      
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: String(this.giftBoxingProductId),
          quantity: 0
        })
      });
      
      const state = await response.json();
      
      await this.cartDrawer.render(state);
      this.restoreScrollPosition();
      this.hidePreloader();
      
    } catch (error) {
      console.error('Error removing gift wrap:', error);
      this.hidePreloader();
    }
  }

  // Update cart note with gift information
  async updateCartNote(note) {
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note })
      });
      
      if (!response.ok) {
        throw new Error('Failed to update cart note');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error updating cart note:', error);
      throw error;
    }
  }

  // Clear cart note and field values
  async clearNote() {
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: '' })
      });
      
      if (!response.ok) {
        throw new Error('Failed to clear cart note');
      }
      
      this.clearFieldValues();
      this.lastSavedNote = '';
      return await response.json();
    } catch (error) {
      console.error('Error clearing cart note:', error);
      throw error;
    }
  }


  clearFieldValues() {
    if (this.noteFields.to) this.noteFields.to.value = "";
    if (this.noteFields.from) this.noteFields.from.value = "";
    if (this.noteFields.message) this.noteFields.message.value = "";
  }

  // Check if gift wrap product is in cart
  isGiftWrapInCart(cartData) {
    return cartData.items.some(item => item.id === this.giftBoxingProductId);
  }

  // Check if cart only contains restricted products
  hasOnlyRestrictedProducts(cartData) {
    const paidProducts = cartData.items.filter(item => item.line_price > 0);
    if (paidProducts.length === 0) return false;
    
    return paidProducts.every(item => 
      this.restrictedProductIds.includes(item.product_id)
    );
  }


  expandFields() {
    const form = this.querySelector(".cart-note-checkbox-form");
    if (form) {
      form.classList.add("show");
      setTimeout(() => {
        form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 300);
    }
  }


  collapseFields() {
    const form = this.querySelector(".cart-note-checkbox-form");
    if (form) {
      form.classList.remove("show");
    }
  }


  showPreloader() {
    const preloader = this.querySelector('.gift-form-preloader');
    if (preloader) {
      preloader.classList.remove('hidden-el');
    }
  }


  hidePreloader() {
    const preloader = this.querySelector('.gift-form-preloader');
    if (preloader) {
      preloader.classList.add('hidden-el');
    }
  }


  disableFields() {
    if (this.noteFields.to) this.noteFields.to.disabled = true;
    if (this.noteFields.from) this.noteFields.from.disabled = true;
    if (this.noteFields.message) this.noteFields.message.disabled = true;
  }


  enableFields() {
    if (this.noteFields.to) this.noteFields.to.disabled = false;
    if (this.noteFields.from) this.noteFields.from.disabled = false;
    if (this.noteFields.message) this.noteFields.message.disabled = false;
  }

  // Scroll position helpers
  saveScrollPosition() {
    if (this.cartDrawer) {
      const scrollContainer = this.cartDrawer.querySelector('.cart-scroll');
      if (scrollContainer) {
        this.scrollPosition = scrollContainer.scrollTop;
      }
    }
  }

  restoreScrollPosition() {
    if (this.cartDrawer && this.scrollPosition !== undefined) {
      const scrollContainer = this.cartDrawer.querySelector('.cart-scroll');
      if (scrollContainer) {
        scrollContainer.scrollTop = this.scrollPosition + 450;
      }
    }
  }

}

customElements.define('gift-box', GiftBox);

function initializeSlickSlider() {
  if ($('.pair-with__container').hasClass('slick-initialized')) {
    $('.pair-with__container').slick('unslick');
  }

  $('.pair-with__container').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    infinite: false,
    initialSlide: 0,
    variableWidth: true,
  });
}

function updateShippingDescription() {
  const shippingDescriptionUS = document.querySelector('.shipping-description-us');
  const shippingDescriptionInternational = document.querySelector('.shipping-description-international');

  function setShippingDescription(country) {
    if (country === 'US') {
      if (shippingDescriptionUS) {
        shippingDescriptionUS.classList.add('show');
        shippingDescriptionUS.classList.remove('hide');
      }
      if (shippingDescriptionInternational) {
        shippingDescriptionInternational.classList.add('hide');
        shippingDescriptionInternational.classList.remove('show');
      }
    } else {
      if (shippingDescriptionUS) {
        shippingDescriptionUS.classList.add('hide');
        shippingDescriptionUS.classList.remove('show');
      }
      if (shippingDescriptionInternational) {
        shippingDescriptionInternational.classList.add('show');
        shippingDescriptionInternational.classList.remove('hide');
      }
    }
  }

  const initialCountry = Shopify.country ||'International';
  setShippingDescription(initialCountry);
}


document.addEventListener("DOMContentLoaded", function () {

  if (!window.addedCartListeners) {
    window.addedCartListeners = true;

    document.addEventListener("addtocart", function (event) {
        cartUpdateType = 'add';
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
            enableLoading();
            cartDrawer.render()
              .then(() => {
                disableLoading();
              })
              .catch(error => {
                disableLoading();
              });
        }
    });
}


   updateShippingDescription();

   class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.scrollPosition = 0;
      this.preloader = this.querySelector('.cart-preloader');
      this.show = this.debounce(this.show.bind(this), 200);
    }

    connectedCallback() {
      if (!this.initialized) {
        this.initialized = true;


        document.addEventListener("cartlink:click", () => {
          this.show();
        });

        document.addEventListener("addtocart", () => {
          this.show();
        });


        if (Theme.URLParams.has("cart")) {
          if (!this.classList.contains("state--active")) {
            this.show();
          }
        }
      }
    }

    debounce(func, wait) {
      let timeout;
      return function() {
        const context = this, args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
      };
    }

    show() {
      setTimeout(() => {
        this.classList.add("state--active");
        this.updateURLWithCartParam(true);
      }, 50);
    }

    hide() {
      this.classList.remove("state--active");
      this.updateURLWithCartParam(false);
    }

    updateURLWithCartParam(isCartOpen) {
      const url = new URL(window.location);
      if (isCartOpen) {
        url.searchParams.set('cart', 'true');
      } else {
        url.searchParams.delete('cart');
      }
      window.history.replaceState({}, '', url);
    }

    async change(data) {
      try {
        const response = await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            'Content-Type': "application/json"
          },
          body: JSON.stringify(data)
        });
        return await response.json();
      } catch (error) {
        console.error('Error changing cart item:', error);
      }
    }

    async fetchCart() {
      try {
        const response = await fetch("/cart.js");
        const cartData = await response.json();
        return cartData;
      } catch (error) {
        console.error('Error fetching cart:', error);
      }
    }

    async render() {
      const current_content = document.getElementById("cart-content");
      const stackContainer = current_content ? current_content.querySelector('.stack--1') : null;

      this.scrollPosition = stackContainer ? stackContainer.scrollTop : 0;

      function get_new_content(response) {
        const string = JSON.parse(response)["cart-drawer"];
        const parser = new DOMParser();
        const doc = parser.parseFromString(string, "text/html");

        return doc.getElementById("cart-content");
      }

      try {
        const response = await fetch("/?sections=cart-drawer");
        const text = await response.text();
        current_content.replaceWith(get_new_content(text));
        updatePromoThreshold();
        updateSubheadingMaxWidth();
        initializeSlickSlider();
        updateShippingDescription();
        cartItemTooltip();
        
        // Sync gift wrap state with cart after render
        setTimeout(() => {
          const giftBoxElement = document.querySelector('gift-box');
          if (giftBoxElement) {
            giftBoxElement.syncWithCartState();
          }
        }, 100);

        const newStackContainer = document.getElementById("cart-content") ? document.getElementById("cart-content").querySelector('.stack--1') : null;
        if (cartUpdateType === 'add' || cartUpdateType === 'remove') {
          setTimeout(() => {
            const pairWithWrapper = document.querySelector('.pair-with-wrapper');
            const cartMinisWrapper = document.querySelector('cart-samples');
            const cartItems = document.querySelector('.cart-items');

            if (pairWithWrapper) {
              pairWithWrapper.scrollIntoView({ behavior: 'smooth', block: 'end' });
            } else if (cartMinisWrapper) {
              cartItems.scrollIntoView({ behavior: 'smooth', block: 'end' });
            } else {
              if (newStackContainer) {
                newStackContainer.scrollTop = this.scrollPosition;
              }
            }
          }, 300);
        } else {
          if (newStackContainer) {
            newStackContainer.scrollTop = this.scrollPosition;
          }
        }

        cartUpdateType = 'none';

      } catch (error) {
        console.error('Error rendering cart drawer:', error);
      }
    }
  }

  customElements.define("cart-drawer", CartDrawer);

  // Shared helper for gift box logic
  class CartGiftBoxHelper {
    constructor() {
      this.giftBoxingProductId = 334827469;
      this.restrictedProductIds = [1687467163737, 1687442587737, 6056491450555, 2016087801945];
    }

    getGiftBoxedProductIds() {
      const idsInput = document.getElementById("giftboxed_product_ids");
      if (idsInput && idsInput.value.trim() !== "") {
        return idsInput.value.split(",").map(Number);
      }
      return this.restrictedProductIds;
    }

    shouldRemoveGiftBox(cartData) {
      const giftBoxedProductIds = this.getGiftBoxedProductIds();
      const isGiftBoxPresent = cartData.items.some(
        item => item.product_id === this.giftBoxingProductId
      );
      
      if (!isGiftBoxPresent) return false;

      const remainingItems = cartData.items.filter(
        item => item.line_price > 0 && item.product_id !== this.giftBoxingProductId
      );
      
      const restrictedProducts = remainingItems.filter(
        item => giftBoxedProductIds.includes(item.product_id)
      ).length;

      // Remove gift box if only restricted products remain
      return remainingItems.length === restrictedProducts && restrictedProducts > 0;
    }

    shouldRemoveIfOnlyGiftBox(cartData, removalUpdates) {
      const remainingCartItems = cartData.items.filter(
        item => !removalUpdates.hasOwnProperty(item.key)
      );
      
      return remainingCartItems.length === 1 && 
             remainingCartItems[0].product_id === this.giftBoxingProductId;
    }

    async clearGiftNote() {
      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: '' })
        });
        
        if (!response.ok) {
          throw new Error('Failed to clear cart note');
        }
        
        return await response.json();
      } catch (error) {
        console.error('Error clearing gift note:', error);
        throw error;
      }
    }

    processGiftBoxRemoval(cartData, removalUpdates, asyncOperations) {
      if (this.shouldRemoveGiftBox(cartData)) {
        const giftBoxItem = cartData.items.find(
          item => item.product_id === this.giftBoxingProductId
        );
        if (giftBoxItem) {
          removalUpdates[giftBoxItem.key] = 0;
          asyncOperations.push(this.clearGiftNote());
        }
      }

      if (this.shouldRemoveIfOnlyGiftBox(cartData, removalUpdates)) {
        const lastItem = cartData.items.find(
          item => !removalUpdates.hasOwnProperty(item.key) && 
                  item.product_id === this.giftBoxingProductId
        );
        if (lastItem) {
          removalUpdates[lastItem.key] = 0;
          asyncOperations.push(this.clearGiftNote());
        }
      }
    }
  }

  const giftBoxHelper = new CartGiftBoxHelper();

  function processPromoProdRemoval(promoId, itemToRemove, updatedCartData, removalUpdates, isQuantityChange = false) {
    const idPrefix = promoId === 'first' ? 'promo-prod' : 'second-promo-prod';
    const enabledInput = document.getElementById(`${idPrefix}-enabled`);
    const isEnabled = enabledInput && enabledInput.value === 'true';
    
    if (!isEnabled) return;

    const qualifyingIds = [];
    const qualifyingSingle = document.getElementById(`${idPrefix}-qualifying-variant`);
    if (qualifyingSingle) qualifyingIds.push(String(qualifyingSingle.value));
    const qualifyingMany = document.querySelectorAll(`[id^="${idPrefix}-qualifying-product-"]`);
    qualifyingMany.forEach(inp => qualifyingIds.push(String(inp.value)));

    const removedWasQualifying = itemToRemove && qualifyingIds.includes(String(itemToRemove.id));
    const qualifyingItemsRemaining = isQuantityChange 
      ? (updatedCartData.items || []).filter(it => qualifyingIds.includes(String(it.id)))
      : null;
    const noneRemaining = isQuantityChange ? qualifyingItemsRemaining.length === 0 : false;

    if (removedWasQualifying || (isQuantityChange && noneRemaining)) {
      const promoProdSection = document.querySelector(`promo-prod-section[data-promo-id="${promoId}"]`);
      if (promoProdSection) {
        const promoProdRadios = Array.from(promoProdSection.querySelectorAll('.promo-radio'));
        const promoProdVariantIds = promoProdRadios.map(r => String(r.value));

        updatedCartData.items.forEach(item => {
          if (promoProdVariantIds.includes(String(item.id))) {
            removalUpdates[item.key] = 0;
          }
        });
      }
    }
  }

  class CartItemRemove extends HTMLElement {
    constructor() {
      super();
      this.rebind();
    }

    rebind() {
      const CartDrawer = this.closest("cart-drawer");
      if (!CartDrawer) return;

      const key = this.getAttribute("key");
      if (!key) return;

      const data = { id: key, quantity: 0 };

      this.addEventListener("click", async (event) => {
        event.preventDefault();

        enableLoading();
        cartUpdateType = "remove";

        try {
          const cartData = await CartDrawer.fetchCart();
          const itemToRemove = cartData.items.find((item) => item.key === key);
          const updatedCartData = await CartDrawer.change(data);

          const removalUpdates = {};
          const asyncOperations = [];

          // Process gift box removal using shared helper
          giftBoxHelper.processGiftBoxRemoval(updatedCartData, removalUpdates, asyncOperations);

          const sampleQualifyingProductsInput = document.getElementById("samples_qualifying_products").value;
          const sampleQualifyingProducts = sampleQualifyingProductsInput.split(",").map((product) => product.trim());
          const remainingSampleQualifyingItems = updatedCartData.items.filter((item) => sampleQualifyingProducts.includes(item.handle));

          if (remainingSampleQualifyingItems.length === 0) {
            const sampleInputs = document.querySelectorAll(".cart-minis input");
            sampleInputs.forEach((input) => {
              const sampleId = input.value;
              const sampleInCart = updatedCartData.items.find((item) => item.variant_id == sampleId);
              if (sampleInCart) {
                removalUpdates[sampleInCart.key] = 0;
              }
            });
          }

          ['first', 'second'].forEach(promoId => {
            processPromoProdRemoval(promoId, itemToRemove, updatedCartData, removalUpdates, false);
          });

          const promoEnabledInput = document.getElementById('promo-enabled');
          const isPromoEnabled = promoEnabledInput && promoEnabledInput.value === 'true';
          if (isPromoEnabled) {
            const allRadios = Array.from(document.querySelectorAll('.promo-radio'));
            const firstTierProductIds = allRadios
              .filter(radio => radio.dataset.tier === '1')
              .map(radio => String(radio.value));
            const secondTierProductIds = allRadios
              .filter(radio => radio.dataset.tier === '2')
              .map(radio => String(radio.value));
            const firstTierItemInCart = updatedCartData.items.find(item =>
              firstTierProductIds.includes(String(item.id))
            );
            const secondTierItemInCart = updatedCartData.items.find(item =>
              secondTierProductIds.includes(String(item.id))
            );
            if (firstTierItemInCart && this.isBelowPromoThreshold(updatedCartData, '1', [firstTierItemInCart])) {
              removalUpdates[firstTierItemInCart.key] = 0;
            }
            if (secondTierItemInCart && this.isBelowPromoThreshold(updatedCartData, '2', [firstTierItemInCart, secondTierItemInCart].filter(Boolean))) {
              removalUpdates[secondTierItemInCart.key] = 0;
            }
          }



          if (Object.keys(removalUpdates).length > 0) {
            asyncOperations.push(this.additionalCartUpdates(removalUpdates));
          }

          await Promise.all(asyncOperations);
          await CartDrawer.render();
          disableLoading();

        } catch (error) {
          console.error('Error in cart item remove:', error);
          disableLoading();
        }
      });
    }

    async additionalCartUpdates(updates) {
      try {
        const response = await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates })
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        return await response.json();
      } catch (error) {
        console.error('Error updating cart:', error);
        throw error;
      }
    }

    isBelowPromoThreshold(cartData, tier = '1', promoItemsToExclude = []) {
      const thresholdId = tier === '1' ? "promo-threshold-converted" : "second-promo-threshold-converted";
      const promoThresholdElement = document.getElementById(thresholdId);
      const promoThreshold = promoThresholdElement ? parseInt(promoThresholdElement.value, 10) : 0;

      let totalExcludingGiftCards = cartData.total_price;
      cartData.items.forEach((item) => {
        if (item.product_type === "Gift Card" || item.sku === "GFT100") {
          totalExcludingGiftCards -= item.price;
        }
      });

      promoItemsToExclude.forEach(item => {
        totalExcludingGiftCards -= item.final_line_price;
      });

      return totalExcludingGiftCards <= promoThreshold;
    }
  }

  customElements.define("cart-item-remove", CartItemRemove);

  class CartItemQuantity extends HTMLElement {
    constructor() {
      super();
      this.rebind();
    }

    rebind() {
      const CartDrawer = this.closest("cart-drawer");
      if (!CartDrawer) return;

      const key = this.getAttribute("key");
      const quantity = Number(this.getAttribute("quantity"));
      let data = { id: key, quantity: quantity };

      this.addEventListener("click", async (event) => {
        if (event.target.nodeName === "BUTTON") {
          data.quantity += Number(event.target.dataset.increment);

          enableLoading();

          try {
            const updatedCartData = await CartDrawer.change(data);
            const removalUpdates = {};
            const asyncOperations = [];

            // Process gift box removal using shared helper
            giftBoxHelper.processGiftBoxRemoval(updatedCartData, removalUpdates, asyncOperations);

            const sampleQualifyingProductsInput = document.getElementById("samples_qualifying_products").value;
            const sampleQualifyingProducts = sampleQualifyingProductsInput.split(",").map((product) => product.trim());
            const remainingSampleQualifyingItems = updatedCartData.items.filter((item) =>
              sampleQualifyingProducts.includes(item.handle)
            );

            if (remainingSampleQualifyingItems.length === 0) {
              const sampleInputs = document.querySelectorAll(".cart-minis input");
              sampleInputs.forEach((input) => {
                const sampleId = input.value;
                const sampleInCart = updatedCartData.items.find(
                  (item) => item.variant_id == sampleId
                );
                if (sampleInCart) {
                  removalUpdates[sampleInCart.key] = 0;
                }
              });
            }

            ['first', 'second'].forEach(promoId => {
              processPromoProdRemoval(promoId, null, updatedCartData, removalUpdates, true);
            });

            const promoEnabledInput = document.getElementById('promo-enabled');
            const isPromoEnabled = promoEnabledInput && promoEnabledInput.value === 'true';
            if (isPromoEnabled) {
              const allRadios = Array.from(document.querySelectorAll('.promo-radio'));
              const firstTierProductIds = allRadios
                .filter(radio => radio.dataset.tier === '1')
                .map(radio => String(radio.value));
              const secondTierProductIds = allRadios
                .filter(radio => radio.dataset.tier === '2')
                .map(radio => String(radio.value));
              const firstTierItemInCart = updatedCartData.items.find(item =>
                firstTierProductIds.includes(String(item.id))
              );
              const secondTierItemInCart = updatedCartData.items.find(item =>
                secondTierProductIds.includes(String(item.id))
              );
              if (firstTierItemInCart && this.isBelowPromoThreshold(updatedCartData, '1', [firstTierItemInCart])) {
                removalUpdates[firstTierItemInCart.key] = 0;
              }
              if (secondTierItemInCart && this.isBelowPromoThreshold(updatedCartData, '2', [firstTierItemInCart, secondTierItemInCart].filter(Boolean))) {
                removalUpdates[secondTierItemInCart.key] = 0;
              }
            }

            if (Object.keys(removalUpdates).length > 0) {
              asyncOperations.push(this.additionalCartUpdates(removalUpdates));
            }

            await Promise.all(asyncOperations);
            await CartDrawer.render();
            disableLoading();

          } catch (error) {
            console.error('Error in cart item quantity change:', error);
            disableLoading();
          }
        }
      });
    }

    async additionalCartUpdates(updates) {
      try {
        const response = await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates })
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        return await response.json();
      } catch (error) {
        console.error('Error updating cart:', error);
        throw error;
      }
    }

    isBelowPromoThreshold(cartData, tier = '1', promoItemsToExclude = []) {
      const thresholdId = tier === '1' ? "promo-threshold-converted" : "second-promo-threshold-converted";
      const promoThresholdElement = document.getElementById(thresholdId);
      const promoThreshold = promoThresholdElement ? parseInt(promoThresholdElement.value, 10) : 0;

      let totalExcludingGiftCards = cartData.total_price;
      cartData.items.forEach((item) => {
        if (item.product_type === "Gift Card" || item.sku === "GFT100") {
          totalExcludingGiftCards -= item.price;
        }
      });

      promoItemsToExclude.forEach(item => {
        totalExcludingGiftCards -= item.final_line_price;
      });

      return totalExcludingGiftCards <= promoThreshold;
    }
  }

  customElements.define("cart-item-quantity", CartItemQuantity);

  class CartOverlay extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("click", (event) => {
        event.preventDefault();
        Shopify.updateCartOnAdd();
        this.closest("cart-drawer").hide();
      });
    }
  }

  customElements.define("cart-overlay", CartOverlay);

  class CartClose extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("click", (event) => {
        event.preventDefault();
        Shopify.updateCartOnAdd();
        this.closest("cart-drawer").hide();
      });
    }
  }

  customElements.define("cart-close", CartClose);


  function updateSubheadingMaxWidth() {
    const cartItems = document.querySelectorAll(".cart-item");
    cartItems.forEach(item => {
      const heading = item.querySelector(".cart-item-heading");
      const subheading = item.querySelector(".cart-item-subheading");
      if (heading && subheading) {
        const headingWidth = heading.getBoundingClientRect().width;
        const maxSubheadingWidth = headingWidth * 1.1;
        subheading.style.maxWidth = maxSubheadingWidth + "px";
      }
    });

  }

  updatePromoThreshold();
  updateShippingDescription();
  updateSubheadingMaxWidth();
  window.addEventListener('resize', updateSubheadingMaxWidth);
  initializeSlickSlider();
  cartItemTooltip();
});

